<section class="legal-page" aria-label="Polityka prywatnosci">
  <header class="legal-header">
    <p class="legal-tag">Dokument prawny</p>
    <h1>Polityka prywatnosci</h1>
    <p>
      Dokument okresla zasady przetwarzania danych osobowych i danych technicznych
      osob odwiedzajacych serwis.
    </p>
  </header>

  <article class="legal-card">
    <h2>1. Administrator danych</h2>
    <p>
      Administratorem danych osobowych jest Waldemar Grzechnik,
      ul. Obozowa 41/45, 30-383 Krakow.
    </p>

    <h2>2. Cele i podstawy przetwarzania</h2>
    <p>Dane moga byc przetwarzane w celu:</p>
    <ul>
      <li>udzielenia odpowiedzi na zapytania kierowane telefonicznie lub mailowo,</li>
      <li>realizacji uslug medycznych i kontaktu organizacyjnego,</li>
      <li>analizy ruchu na stronie, statystyki odwiedzin i poprawy funkcjonalnosci serwisu,</li>
      <li>zapewnienia bezpieczenstwa i poprawnego dzialania serwisu,</li>
      <li>ustalenia, dochodzenia lub obrony przed roszczeniami.</li>
    </ul>
    <p>
      Podstawa prawna przetwarzania: art. 6 ust. 1 lit. a, b, c oraz f RODO.
    </p>

    <h2>3. Zakres danych</h2>
    <p>
      W zaleznosci od formy kontaktu przetwarzane moga byc dane identyfikacyjne i kontaktowe,
      a takze dane techniczne zapisywane automatycznie w logach serwera.
    </p>

    <h2>4. Odbiorcy danych</h2>
    <p>
      Dane moga byc powierzane podmiotom wspierajacym utrzymanie infrastruktury IT i hostingu,
      wyłącznie w zakresie niezbednym do realizacji wskazanych celow.
    </p>

    <h2>5. Okres przechowywania</h2>
    <p>
      Dane przechowywane sa przez okres niezbedny do realizacji celu przetwarzania,
      a logi techniczne serwera przez okres do 5 lat, z uwagi na wymogi bezpieczenstwa,
      ciaglosci uslug i ewentualnej obrony przed roszczeniami.
    </p>

    <h2>6. Prawa osoby, ktorej dane dotycza</h2>
    <p>Przysluguje Panstwu prawo do:</p>
    <ul>
      <li>dostepu do danych,</li>
      <li>sprostowania danych,</li>
      <li>usuniecia danych lub ograniczenia przetwarzania,</li>
      <li>wniesienia sprzeciwu wobec przetwarzania,</li>
      <li>wniesienia skargi do Prezesa Urzedu Ochrony Danych Osobowych.</li>
    </ul>
    <p>
      Uprawnienia te nie obejmuja danych technicznych zapisywanych w logach serwera,
      ktore sa przechowywane w zakresie niezbednym dla bezpieczenstwa, administracji
      serwisu oraz obrony przed roszczeniami, zgodnie z obowiazujacymi przepisami.
    </p>

    <h2>7. Cookies i technologie podobne</h2>
    <p>
      Serwis korzysta z niezbednych mechanizmow technicznych wymaganych do poprawnego
      dzialania uslugi www. Po wyrazeniu zgody moze takze korzystac z cookies i podobnych
      technologii analitycznych, w tym narzedzi Google Analytics, aby:
    </p>
    <ul>
      <li>mierzyc ruch na stronie i sposob korzystania z serwisu,</li>
      <li>analizowac rodzaj urzadzenia, system operacyjny, przegladarke, przyblizona lokalizacje i zrodlo wejscia,</li>
      <li>oceniac odwiedzane podstrony, czas spędzony w serwisie, sciezki nawigacji oraz interakcje z trescia,</li>
      <li>ulepszac tresci, funkcjonalnosc oraz wydajnosc serwisu.</li>
    </ul>
    <p>
      Dane wykorzystywane w tym celu sa przetwarzane w formie statystycznej i co do zasady nie
      sluza do bezposredniej identyfikacji uzytkownika. Zgoda moze zostac w kazdej chwili
      wycofana poprzez zmiane ustawien cookies lub przegladarki.
    </p>

    <h2>8. Logi serwera</h2>
    <p>
      Podczas korzystania z serwisu automatycznie zapisywane moga byc dane techniczne,
      m.in. adres IP, data i czas zapytania, identyfikator zasobu oraz informacje o przegladarce.
      Dane te sa wykorzystywane w celach administracyjnych i bezpieczenstwa.
    </p>

    <h2>9. Kontakt</h2>
    <p>
      W sprawach zwiazanych z danymi osobowymi prosimy o kontakt z administratorem na adres:
      Waldemar Grzechnik, ul. Obozowa 41/45, 30-383 Krakow.
    </p>
  </article>

  <p class="legal-back">
    <a routerLink="/">Wroc do strony glownej</a>
  </p>
</section>
